import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import { i18n } from "@i18n";
import Message from '@/components/Message/index.js'
import "@/plugins/vue-log";

Vue.config.productionTip = false;
Vue.prototype.$message = Message

const Office = window.Office;
Office.onReady(() => {
  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App),
  }).$mount("#app");

});
